import { TotalResponseModel } from "./total-response.model";

export class PagedResponseModel<T> {
  items: T[] = [];
  totals: TotalResponseModel[] = [];
  totalItems: number = 0;
  totalPages: number = 0;
  currentPage: number = 0;
  pageSize: number = 10;
}


